import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

// Store
import {
  loadLanguagesList,
  loadLanguagesListSuccess,
  loadLanguagesListError,
} from './languages.actions';

// Services
import { LanguageService } from '@services/language.service';

@Injectable()
export class LanguagesEffects {
  private actions$ = inject(Actions);
  private languageService = inject(LanguageService);

  initLanguagesState$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadLanguagesList),
      switchMap(() =>
        this.languageService.getLanguagesList().pipe(
          map(({ languages }) => loadLanguagesListSuccess({ languages })),
          catchError(error => of(loadLanguagesListError({ error }))),
        ),
      ),
    ),
  );
}
